// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContinueTip_wrapper__3w0KM","tip":"ContinueTip_tip__2i1fw","dangerTip":"ContinueTip_dangerTip__1LfGW","continueBtn":"ContinueTip_continueBtn__ptY50"};